import React from 'react';
import styles from './ImageWithBlurBackground.module.scss';

const ImageWithBlurBackground = ({ src, alt, className = '' }) => {
  return (
    <div className={`${styles.imageContainer} ${className}`}>
      <div 
        className={styles.blurBackground}
        style={{
          backgroundImage: `url(${src})`,
        }}
      />
      <img
        className={styles.mainImage}
        src={src}
        alt={alt}
      />
    </div>
  );
};

export default ImageWithBlurBackground;
